import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Box,
  Typography,
  createStyles,
  withStyles,
  Switch,
} from "@material-ui/core";
import { TENANT_ID } from "../../config/config";

function PartnerToggles({
  classes,
  partner,
  updateAttribute,
  agent,
  skipBalanceCheck,
  mandate2FA,
  integrationRecatBlock,
  hasWriteAccess,
}) {
  const handleToggle = async (key, value) => {
    await updateAttribute(key, !value);
  };

  return (
    <fieldset
      disabled={!hasWriteAccess}
      style={{ border: "none", padding: 0, margin: 0 }}
    >
      <Box className={classes.root}>
        <Box py={2} px={2} my={2} className={classes.container}>
          <Typography
            variant="body1"
            gutterBottom
            style={{ fontWeight: "bold" }}
          >
            Skip campaign balance check
          </Typography>
          <Box my={2} style={{ display: "flex", alignItems: "center" }}>
            <Switch
              name="skipBalanceCheck"
              checked={partner?.skipBalanceCheck || false}
              onChange={(e) => skipBalanceCheck(e)}
              inputProps={{ "aria-label": "secondary checkbox" }}
            />
          </Box>
        </Box>

        <Box py={2} px={2} my={2} className={classes.container}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            Bypass OTP restriction at IP level
          </Typography>
          <Box my={2} style={{ display: "flex", alignItems: "center" }}>
            <Switch
              name="skipIPCheck"
              checked={partner?.skipIPCheck || false}
              onClick={() =>
                handleToggle("skipIPCheck", partner?.skipIPCheck || false)
              }
              inputProps={{ "aria-label": "secondary checkbox" }}
            />
          </Box>
        </Box>

        {/* PTR-136: whitelabel partners own the login experience their end
            clients see, so they are the only ones who can require 2FA on it.
            The server enforces this too — the toggle is not the only guard. */}
        {partner?.type === "WHITELABEL" && (
          <Box py={2} px={2} my={2} className={classes.container}>
            <Typography variant="body1" style={{ fontWeight: "bold" }}>
              Mandate 2FA for all businesses
            </Typography>
            <Typography variant="body2" color="textSecondary">
              The default for every business under this partner: each of their
              agents must enable two-factor authentication before they can use
              the dashboard or APIs. The partner can override this for an
              individual business from their own dashboard.
            </Typography>
            <Box my={2} style={{ display: "flex", alignItems: "center" }}>
              <Switch
                name="mandate2FA"
                checked={partner?.mandate2FA || false}
                onClick={() => mandate2FA(!(partner?.mandate2FA || false))}
                inputProps={{ "aria-label": "secondary checkbox" }}
              />
            </Box>
          </Box>
        )}

        {/* INT-118: whitelabel only, same as 2FA. The server enforces this too. */}
        {partner?.type === "WHITELABEL" && (
          <Box py={2} px={2} my={2} className={classes.container}>
            <Typography variant="body1" style={{ fontWeight: "bold" }}>
              Block integration sends on Utility → Marketing
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Lets this partner's businesses turn on blocking of CleverTap,
              MoEngage, WebEngage, LeadSquared and PayU sends for templates Meta
              moves from Utility to Marketing. Each business opts in from its
              Campaign Settings. Turning this off stops the blocking for all of
              them.
            </Typography>
            <Box my={2} style={{ display: "flex", alignItems: "center" }}>
              <Switch
                name="integrationRecatBlockEnabled"
                checked={partner?.integrationRecatBlockEnabled || false}
                onClick={() =>
                  integrationRecatBlock(
                    !(partner?.integrationRecatBlockEnabled || false)
                  )
                }
                inputProps={{ "aria-label": "secondary checkbox" }}
              />
            </Box>
          </Box>
        )}

        {/* {!TENANT_ID && (
        <Box py={2} px={2} my={2} className={classes.container}>
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            WCC Payment Automation for Whitelabel
          </Typography>
          <Box my={2} style={{ display: "flex", alignItems: "center" }}>
            {agent.power <= 10 ? (
              <></>
            ) : (
              <Switch
                name="isRazorpayEnabled"
                checked={partner?.isRazorpayEnabled || false}
                onClick={() =>
                  handleToggle(
                    "isRazorpayEnabled",
                    partner?.isRazorpayEnabled || false
                  )
                }
                inputProps={{ "aria-label": "secondary checkbox" }}
              />
            )}
          </Box>
        </Box>
      )} */}
      </Box>
    </fieldset>
  );
}

const styles = (theme) =>
  createStyles({
    root: {
      paddingTop: 20,
      overflowX: "hidden",
    },
    container: {
      background: "#EBF5F3",
      borderRadius: "15px",
    },
  });
const connectedPartnerToggles = connect((state) => ({
  agent: state.login.user,
}))(PartnerToggles);
export default withStyles(styles)(connectedPartnerToggles);
